import {NgModule} from '@angular/core';
import {SimpleImageVariantPipe} from './simple-image-variant.pipe';

@NgModule({
  declarations: [SimpleImageVariantPipe],
  exports: [SimpleImageVariantPipe],
})
export class SimpleImageVariantModule {}
